export function amountToString(value: number): string {
    return new Intl.NumberFormat("nl-BE").format(value)
}
